module.exports = __webpack_public_path__ + "img/kf3.8898c055.jpg";